module.exports = __webpack_public_path__ + "static/floating-action-button-action-styles-do-671d711bce9f81f0241d0100f054fa5b.png";